/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MessageThreadMetadataRepresentationFromJSON, MessageThreadMetadataRepresentationToJSON, } from './';
export function MessageThreadRepresentationFromJSON(json) {
    return MessageThreadRepresentationFromJSONTyped(json, false);
}
export function MessageThreadRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        anchor: json['anchor'],
        creatorId: json['creatorId'],
        creationTime: new Date(json['creationTime']),
        lastUpdateTime: new Date(json['lastUpdateTime']),
        metadata: MessageThreadMetadataRepresentationFromJSON(json['metadata']),
    };
}
export function MessageThreadRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        anchor: value.anchor,
        creatorId: value.creatorId,
        creationTime: value.creationTime.toISOString(),
        lastUpdateTime: value.lastUpdateTime.toISOString(),
        metadata: MessageThreadMetadataRepresentationToJSON(value.metadata),
    };
}
